import React from 'react';
import styled from 'styled-components';

export const NoDataMessage = ({ text = 'Braaap, go ride!' }) => (
  <Wrapper>
    <i className="fa fa-motorcycle" />
    {text}
  </Wrapper>
);

export default NoDataMessage;

const Wrapper = styled.div`
  display: flex;
  width: 98vw;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-size: clamp(1.5rem, 2vw, 3rem);
  color: rgba(255, 255, 255, 0.2) !important;
  font-weight: 900;
  & i {
    margin-right: 10px;
    color: rgba(255, 255, 255, 0.2);
  }
`;
